module.exports = __webpack_public_path__ + "static/media/BI.e05683e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/BI.svg
// module id = 2113
// module chunks = 7